/**
 * AI CONTEXT
 * Purpose: route-derived flag for front-desk context styling/behavior.
 * Logic: true when pathname includes /front-desk.
 * Used by: Admin widgets that change layout in SuperView.
 * Refactor: centralize route-mode detection in one app-level location helper.
 */
import { useLocation } from "react-router-dom"

const useIsSuperView = () => {
  const location = useLocation()
  return location.pathname.includes("/front-desk")
}

export default useIsSuperView
